import { logger } from 'src/logger';
import { ResourceAttributes } from 'src/state/slice/models/CaseLifecycleTypes';

/**
 * Get preferred account
 * @param accountAttributes accountAttributes
 * @param preselectedAccountId preselected account id
 * @returns
 */
export function getPreferredAccount(
  preselectedAccountId?: string | null,
  accountAttributes?: ResourceAttributes[],
): string {
  if (preselectedAccountId) {
    return preselectedAccountId;
  }
  if (
    !accountAttributes ||
    !Array.isArray(accountAttributes) ||
    accountAttributes.length === 0
  ) {
    return '';
  }
  return accountAttributes[0].id;
}

export const validateAuthorizedEmail = (
  emailId: string,
  emailDomain: string,
) => {
  if (!emailId) {
    logger.error('Email id is invalid', {
      emailId,
    });
    return false;
  }
  const org = emailId.split('@');
  if (!org || org.length < 2) {
    logger.error('Email format is invalid', {
      emailId,
    });
    return false;
  }
  const currentEmailDomain = org[1];
  const emailDomainList = emailDomain.split(',');
  const isEmailValid = emailDomainList.includes(currentEmailDomain);
  if (!isEmailValid) {
    logger.error('Email is invalid for domain', {
      emailId,
      emailDomain,
    });
  }
  return isEmailValid;
};

export const fetchEmailDomain = (
  accountId: string,
  accountAttributes: ResourceAttributes[],
) => {
  const resourceAttributes = fetchResourceAttributes(
    accountId,
    accountAttributes,
  );
  if (resourceAttributes === '') {
    return '';
  }
  return resourceAttributes.attributes.domain;
};

export const fetchAgencyName = (
  accountId: string,
  accountAttributes: ResourceAttributes[],
) => {
  const resourceAttributes = fetchResourceAttributes(
    accountId,
    accountAttributes,
  );
  if (resourceAttributes === '') {
    return '';
  }
  return resourceAttributes.attributes.accountName;
};

export const fetchCountry = (
  accountId: string,
  accountAttributes: ResourceAttributes[],
) => {
  const resourceAttributes = fetchResourceAttributes(
    accountId,
    accountAttributes,
  );
  if (resourceAttributes === '') {
    return '';
  }
  return resourceAttributes.attributes.country;
};

export const fetchRole = (
  accountId: string,
  accountAttributes: ResourceAttributes[],
) => {
  const resourceAttributes = fetchResourceAttributes(
    accountId,
    accountAttributes,
  );
  if (resourceAttributes === '') {
    return '';
  }
  return resourceAttributes.attributes.role;
};

export const fetchResourceAttributes = (
  accountId: string,
  accountAttributes: ResourceAttributes[],
): ResourceAttributes | '' => {
  if (!accountId) {
    logger.error('Account id is invalid. Agency is not fetched', {
      accountId,
      accountAttributes,
    });
    return '';
  }
  const agencyNameIndex =
    accountAttributes.length > 0
      ? accountAttributes.findIndex(
          (accountAttribute) => accountAttribute.id === accountId,
        )
      : -1;
  if (agencyNameIndex === -1) {
    logger.error('Unable to find accountId in accountAttributes map', {
      accountId,
      accountAttributes,
    });
    return '';
  }
  return accountAttributes[agencyNameIndex];
};
